import { useEffect, useRef } from "react";
import Hls from "hls.js";

import { useMediaContext } from "../../contexts/MediaContext";
import { usePlayerStore } from "../../store/usePlayerStore";

import useSetupHlsJs from "./useSetupHlsJs";
import useSetupNativeHls from "./useSetupNativeHls";

const useHls = ({
  destroy,
  setIsMediaAttached,
  subtitleDisplay,
  usingServiceScheduleTracks,
  video
}: {
  destroy: boolean;
  setIsMediaAttached: (value: boolean) => void;
  subtitleDisplay?: boolean;
  usingServiceScheduleTracks: boolean;
  video?: HTMLVideoElement;
}) => {
  const { useStoreState } = usePlayerStore();
  const isPlayerSetupStarted = useStoreState.isPlayerSetupStarted();

  const setIsPlayerSetupStarted = useStoreState.setIsPlayerSetupStarted();

  const hlsRef = useRef<Hls | undefined>();

  const { manifestUrl } = useMediaContext();

  const setupHlsJs = useSetupHlsJs({
    destroy,
    setIsMediaAttached,
    subtitleDisplay,
    usingServiceScheduleTracks,
    video
  });

  const setupNative = useSetupNativeHls({
    setIsMediaAttached,
    usingServiceScheduleTracks,
    video
  });

  useEffect(() => {
    if (manifestUrl && video && !isPlayerSetupStarted) {
      setIsPlayerSetupStarted(true);
      if (Hls.isSupported()) {
        hlsRef.current = setupHlsJs();
      } else {
        setupNative();
      }
    }
  }, [
    isPlayerSetupStarted,
    manifestUrl,
    setIsPlayerSetupStarted,
    setupHlsJs,
    setupNative,
    video
  ]);

  return hlsRef.current;
};

export default useHls;
